export { default as LsReport } from './LSReport.vue';

